import { create } from "zustand"
import { asRecord } from "~/utils/helpers"

type ActiveFileType = any
type BulkGenerateState = Record<string, boolean>

interface IUseRfpOSStore {
  activeFile: ActiveFileType
  setActiveFile: (file: ActiveFileType) => void
  // Whether the currently-selected file is a standard proposal template
  // (backend `is_standard_template` flag). Set once at the route level so
  // deeply-nested components can gate template-only UI without prop-drilling
  // the file list or hardcoding id conventions.
  isActiveFileStandardTemplate: boolean
  setIsActiveFileStandardTemplate: (val: boolean) => void
  bulkGenerate: BulkGenerateState | null
  setBulkGenerate: (value: BulkGenerateState) => void
  showContributorModal: any
  setShowContributorModal: (val: any) => void
  showEditSectionModal: any
  setShowEditSectionModal: (val: any) => void
  showEditQuestionModal: any
  setShowEditQuestionModal: (val: any) => void
  addSection: any
  setAddSection: (val: any) => void
  openSearchLibrary: any
  setOpenSearchLibrary: (val: any) => void
  openSearchImage: any
  setOpenSearchImage: (val: any) => void
  sectionCollaborators: string[]
  setSectionCollaborators: (val: string[]) => void
  showExecutiveSummary: any
  setShowExecutiveSummary: (val: any) => void
  previewSaveIndex: any
  setPreviewSaveIndex: (val: any) => void
  answerGenerated: boolean
  setAnswerGenerated: (val: boolean) => void
  showGuidance: any
  setShowGuidance: (val: any) => void
  sortQuestions: any
  setSortQuestions: (val: any) => void
  editQuestion: any
  setEditQuestion: (val: any) => void
  showVersions: any
  setShowVersions: (val: any) => void
  rfpLevelGuidance: boolean
  setLevelRfpGuidance: (val: boolean) => void
  sortHeaders: any
  setSortHeaders: (val: any) => void
  currentSessionTitle: string
  setCurrentSessionTitle: (title: string) => void
  showKnowledgeUploadModal: any
  setShowKnowledgeUploadModal: (val: any) => void
  knowledgePopoverOpen: boolean
  setKnowledgePopoverOpen: (val: any) => void
  uploadedFilesLength: number
  setUploadedFilesLength: (val: number) => void
  regenExecSummaryFlag: boolean
  setRegenerateExecSummary: (val: boolean) => void
  myFilesDrawerOpen: boolean
  setMyFilesDrawerOpen: (val: boolean) => void
  asyncBriefingInProgress: boolean
  setAsyncBriefingInProgress: (val: boolean) => void
}

const useRfpOSStore = create<IUseRfpOSStore>((set) => ({
  activeFile: null,
  isActiveFileStandardTemplate: false,
  setIsActiveFileStandardTemplate: (val: boolean) => {
    return set({ isActiveFileStandardTemplate: val })
  },
  setActiveFile: (file: ActiveFileType) => {
    return set({ activeFile: file })
  },
  bulkGenerate: null,
  setBulkGenerate: (value: BulkGenerateState) =>
    set((state) => ({
      bulkGenerate: {
        ...asRecord(state.bulkGenerate),
        ...value
      }
    })),
  showContributorModal: null,
  setShowContributorModal: (val: any) => set({ showContributorModal: val }),
  showEditSectionModal: null,
  setShowEditSectionModal: (val: any) => set({ showEditSectionModal: val }),
  showEditQuestionModal: null,
  setShowEditQuestionModal: (val: any) => set({ showEditQuestionModal: val }),
  addSection: null,
  setAddSection: (val: any) => set({ addSection: val }),
  openSearchLibrary: null,
  setOpenSearchLibrary: (val: any) => set({ openSearchLibrary: val }),
  openSearchImage: null,
  setOpenSearchImage: (val: any) => set({ openSearchImage: val }),
  sectionCollaborators: [],
  setSectionCollaborators: (val: string[]) =>
    set({ sectionCollaborators: val }),
  showExecutiveSummary: null,
  setShowExecutiveSummary: (val: any) => set({ showExecutiveSummary: val }),
  previewSaveIndex: null,
  setPreviewSaveIndex: (val: any) => set({ previewSaveIndex: val }),
  answerGenerated: false,
  setAnswerGenerated: (val: boolean) => set({ answerGenerated: val }),
  showGuidance: null,
  setShowGuidance: (val: any) => set({ showGuidance: val }),
  sortQuestions: null,
  setSortQuestions: (val: any) => set({ sortQuestions: val }),
  editQuestion: null,
  setEditQuestion: (val: any) => set({ editQuestion: val }),
  showVersions: null,
  setShowVersions: (val: any) => set({ showVersions: val }),
  rfpLevelGuidance: false,
  setLevelRfpGuidance: (val: boolean) => set({ rfpLevelGuidance: val }),
  sortHeaders: null,
  setSortHeaders: (val: any) => set({ sortHeaders: val }),
  currentSessionTitle: "",
  setCurrentSessionTitle: (title: string) =>
    set({ currentSessionTitle: title }),
  showKnowledgeUploadModal: null,
  setShowKnowledgeUploadModal: (val: any) =>
    set({ showKnowledgeUploadModal: val }),
  knowledgePopoverOpen: false,
  setKnowledgePopoverOpen: (val: any) => set({ knowledgePopoverOpen: val }),
  uploadedFilesLength: 0,
  setUploadedFilesLength: (val: number) => set({ uploadedFilesLength: val }),
  regenExecSummaryFlag: false,
  setRegenerateExecSummary: (val: boolean) =>
    set({ regenExecSummaryFlag: val }),
  myFilesDrawerOpen: false,
  setMyFilesDrawerOpen: (val: boolean) => set({ myFilesDrawerOpen: val }),
  asyncBriefingInProgress: false,
  setAsyncBriefingInProgress: (val: boolean) =>
    set({ asyncBriefingInProgress: val })
}))

export default useRfpOSStore
